import React, { useEffect, useState } from "react";
import "./UserPendingPayment.scss";
import { UserTitlebar } from "../../Global/User-Flow/UserTitleBar/UserTitleBar";
import {
  GreenDescription,
  PaymentPendingHeading,
  RegisterGreyHeading,
} from "../../Global/GlobalText";
import {
  CheckboxInput,
  CheckboxLabel,
  InputLabel,
  InputType,
  SelectBorder,
} from "../../Global/GlobalFormElement";
import {
  GreenBackgroundButton,
  GreyBorderButton,
  RedBackgroundButton,
} from "../../Global/GlobalButton";
import { RiDeleteBin6Fill } from "react-icons/ri";
import axios from "axios";
import {
  EXCHNAGE_UR_PAYMENTSL,
  EXCHNAGE_URL,
  USER_EXCHNAGE_URL,
} from "../../../Url/Url";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import StripePayment from "./StripePayment";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const stripePromise1 = loadStripe(
  "pk_test_51OrxTQSJn2wgGTOKfzVear9CJ54IvR3ED1EeyTqchSp1kDuOll89wuGBaPNQzFKGuovbPeftr18Jbb6tnyXKsndu00CNwzdhgj"
);

export const UserPendingPayment = () => {
  const [categories, setCategories] = useState([]);
  const [paymentData, setPaymentData] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [coupons, setCoupons] = useState({ discount: 0, subtotal: null });
  const [couponCode, setCouponCode] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("newest");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [paymentGatewayType, setpaymentGatewayType] = useState("");
  const [paymentGatewayKeys, setPaymentGatewayKeys] = useState([]);
  const [stripeKey, setStripeKey] = useState(null);
  const [razorpayKey, setRazorpay] = useState("");
  const [currencyType, setCurrencyType] = useState("");
  const [TaxType, setTaxType] = useState("");
  const [vtPercentage, setVtPrecentage] = useState("");
  const [stripePromise, setStripePromise] = useState(null);
  const location = useLocation();
  const token = localStorage.getItem("token");
  const { eventId } = location.state || {};
  const [gstPercentage, setGstPercentage] = useState("");
  const [vatNumber, setVatNumber] = useState(""); // ✅ NEW STATE
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        let apiUrl = `${EXCHNAGE_URL}/allAwards?eventId=${eventId}&sortOrder=${sortOrder}`;
        if (searchTerm) {
          apiUrl += `&search=${searchTerm}`;
        }
        const response = await axios.get(apiUrl, {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        if (response.status === 200) {
          const data = response.data.data;
          setCategories(data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const currencyRates = {
    INR: 1,
    USD: 0.012,
    AED: 0.044,
  };

  const currencySymbols = {
    INR: "₹",
    USD: "$",
    AED: "د.إ",
  };

  useEffect(() => {
    const fetchPaymentData = async () => {
      try {
        const response = await axios.get(
          `${USER_EXCHNAGE_URL}/getuserseventlist?eventId=${eventId}`,
          {
            headers: {
              "Content-Type": "application/json",
              authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 200) {
          const data = response?.data?.categories;
          const gatewayType = response?.data?.paymentData?.gateway_type;
          const gatewayData = response?.data?.paymentData;
          const curType = response?.data?.paymentData?.currency_type;
          const txType = response?.data?.paymentData?.tax_type;
          const vt = response?.data?.paymentData?.vat_percentage;
          const gst = response?.data?.paymentData?.gst_percentage;
          setPaymentData(data);
          setpaymentGatewayType(gatewayType);
          setPaymentGatewayKeys(gatewayData);
          setCurrencyType(curType);
          setTaxType(txType);
          setVtPrecentage(vt);
          setGstPercentage(gst);
        }
      } catch (error) {
        console.error("Error fetching Data:", error);
      }
    };
    fetchPaymentData();
  }, []);

  useEffect(() => {
    const fetchKeys = async () => {
      try {
        const response = await axios.get(
          `${EXCHNAGE_UR_PAYMENTSL}/stripe-publishable-key?eventid=${eventId}`,
          {
            headers: {
              "Content-Type": "application/json",
              authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 200) {
          const key = response?.data?.publicKey;
          setStripeKey(key);
          const stripe = await loadStripe(key);
          setStripePromise(stripe);
        }
      } catch (error) {
        console.error("Error fetching Stripe key:", error);
      }
    };
    fetchKeys();
  }, [eventId]);

  useEffect(() => {
    const fetchKeysRazorPay = async () => {
      try {
        const response = await axios.get(
          `${EXCHNAGE_UR_PAYMENTSL}/razorpay-publishable-key?eventid=${eventId}`,
          {
            headers: {
              "Content-Type": "application/json",
              authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 200) {
          const key = response?.data?.publicKey;
          setRazorpay(key);
        }
      } catch (error) {
        console.error("Error fetching Stripe key:", error);
      }
    };
    fetchKeysRazorPay();
  }, [eventId]);

  const handleInputChange = (event) => {
    setCouponCode(event.target.value);
  };

  const handleApplyCoupon = async () => {
    if (!couponCode) {
      console.error("Coupon code is required.");
      return;
    }

    try {
      const response = await axios.get(
        `${EXCHNAGE_URL}/couponGet?couponId=${couponCode}&baseTotalPrice=${convertedTotalAmount.toFixed(
          2
        )}&eventId=${eventId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.status === 200) {
        const data = response.data.data;
        setCoupons(data);
      }
    } catch (error) {
      console.error("Error fetching coupons:", error);
    }
  };

  console.log(selectedCategories);
  useEffect(() => {
    // Dynamically load Razorpay script
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      console.log("✅ Razorpay script loaded");
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handlePayment = async () => {
    if (!companyName) {
      toast.error("⚠️ Please enter Company Name.");
      return;
    }

    setLoading(true);
    try {
      const totalPrice = finalAmount || 0;

      // ✅ 1. Create Order on Backend
      const { data } = await axios.post(
        `${EXCHNAGE_UR_PAYMENTSL}/create-order`,
        {
          amount: totalPrice, // Total Price
          currency: "INR",
          gstNumber: currencyType === "INR" ? gstNumber : "",
          vatNumber: currencyType !== "INR" ? vatNumber : "",
          companyName,
          eventId: eventId,
          awardId: 12

        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      const { order } = data;

      if (!window.Razorpay) {
        toast.error("❌ Razorpay SDK failed to load. Please refresh.");
        setLoading(false);
        return;
      }

      // ✅ 2. Open Razorpay Payment Window
      const options = {
        // key: "rzp_test_KyRRnIgWFZ4ilQ", // Your Razorpay Key
        key: razorpayKey || "",
        amount: order.amount,
        currency: order.currency,
        name: companyName,
        description: "Order Payment",
        order_id: order.id,
        handler: async function (response) {
          try {
            // ✅ 3. Verify Payment
            const verifyRes = await axios.post(
              `${EXCHNAGE_UR_PAYMENTSL}/verify-payment`,
              {
                ...response,
                gstNumber,
                companyName,
                eventId: eventId,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`, // Fetch token properly
                  "Content-Type": "application/json",
                },
              }
            );

            if (verifyRes.data.success) {
              toast.success("🎉 Payment Successful!");
              navigate("/user-dashboard");
            } else {
              toast.error("⚠️ Payment Verification Failed!");
            }
          } catch (error) {
            console.error("Verification error:", error);
            toast.error("⚠️ Verification Failed");
          }
        },
        prefill: {
          name: companyName,
          email: "user@example.com",
          contact: "9999999999",
        },
        theme: { color: "#3399cc" },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (error) {
      console.error("❌ Payment Error:", error);
      toast.error("⚠️ RazorPay Payment Failed");
    }
    setLoading(false);
  };

  const totalAmount =
    paymentData?.reduce((acc, category) => {
      return acc + category.totalPayment * category.totalSubmissions;
    }, 0) || 0;

  console.log(totalAmount, "asdasd");

  const convertedTotalAmount = totalAmount;

  const discountedSubtotal = coupons?.subtotal
    ? parseFloat(coupons.subtotal)
    : convertedTotalAmount;
  let taxRate = 0;

  if (TaxType === "VAT") {
    taxRate = (parseFloat(vtPercentage) || 0) / 100;
  } else if (TaxType === "GST") {
    if (gstPercentage) {
      // ✅ backend value use karo
      taxRate = parseFloat(gstPercentage) / 100;
    } else if (currencyType === "INR") {
      // ✅ default India GST
      taxRate = 18 / 100;
    } else {
      // ✅ no GST
      taxRate = 0;
    }
  }
  const gstAmount = (discountedSubtotal * taxRate).toFixed(2);
  const convertedGstAmount = parseFloat(gstAmount);

  const finalAmount = (discountedSubtotal + convertedGstAmount).toFixed(2);

  const currencySymbol = currencySymbols[currencyType] || "₹";

  const handlePaymentSuccess = () => {
    toast.success("🎉 Payment Successful!");
    navigate("/user-dashboard");
  };

  console.log(paymentGatewayType, "paymentttttttttt");
  const renderPaymentMethods = () => {
    if (paymentGatewayType === "stripe" && stripePromise) {
      return (
        <Elements stripe={stripePromise}>
          <StripePayment
            companyName={companyName}
            gstNumber={gstNumber}
            finalAmount={finalAmount}
            eventId={eventId}
            setLoading={setLoading}
            onPaymentSuccess={handlePaymentSuccess}
            currencyType={currencyType}
            currencySymbol={currencySymbol}
              vatNumber={vatNumber}        // ✅ ADD THIS

          />
        </Elements>
      );
    }
    return (
      <RedBackgroundButton onClick={handlePayment} disabled={loading}>
        {loading
          ? "Processing..."
          : `${currencySymbol}${finalAmount || 0} Pay Now`}
      </RedBackgroundButton>
    );
  };

  console.log(TaxType, "asd");

  return (
    <>
      <div className="user_pending_div">
        <UserTitlebar title="Pending Payment" userDetailsColor="#333333" />
        <div className="user_pending_bg">
          <div className="payment_heading">
            <PaymentPendingHeading>Payment Pending</PaymentPendingHeading>
          </div>

          <div className="user_pending_table">
            {paymentData && (
              <table>
                <thead>
                  <tr>
                    <th>Category Name</th>
                    <th>Number Of Submissions</th>
                    <th>Price</th>
                    <th>Subtotal</th>
                    {/* <th>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {paymentData &&
                    paymentData.map((category) => {
                      const rate = currencyRates[currencyType] || 1;
                      const symbol = currencySymbols[currencyType] || "₹";
                      const convertedPrice = category.totalPayment;
                      const convertedTotal =
                        category.totalPayment *
                        category.totalSubmissions;

                      return (
                        <tr key={category.awardId}>
                          <td>{category.categoryName}</td>
                          <td>{category.totalSubmissions}</td>
                          <td>
                            {symbol}
                            {convertedPrice.toFixed(2)}
                          </td>
                          <td>
                            {symbol}
                            {convertedTotal.toFixed(2)}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            )}
            <div className="user_pending_button">
              <InputType
                type="text"
                placeholder="Coupon Code"
                value={couponCode}
                onChange={handleInputChange}
              />
              <GreenBackgroundButton onClick={handleApplyCoupon}>
                Apply Coupon
              </GreenBackgroundButton>
              <GreyBorderButton>Update Cart</GreyBorderButton>
            </div>
          </div>

          <div className="user_main_card_div">
            <div className="user_card_check">
              <div className="user_card_div">
                <RegisterGreyHeading>Cart Total</RegisterGreyHeading>
                <div className="user_pending_amount">
                  <div className="user_amount_sub">
                    <InputLabel>Total Amount</InputLabel>
                    <InputLabel>
                      {currencySymbol}
                      {convertedTotalAmount.toFixed(2)}
                    </InputLabel>
                  </div>

                  <hr className="user_pending_line" />

                  <div className="user_amount_sub">
                    <GreenDescription
                      style={{ fontWeight: 400, fontSize: "14px" }}
                    >
                      Applied Discount Coupon
                    </GreenDescription>
                    <GreenDescription
                      style={{ fontWeight: 400, fontSize: "14px" }}
                    >
                      {coupons.discount || 0}
                    </GreenDescription>
                  </div>
                  <hr className="user_pending_line" />

                  <div className="user_amount_sub">
                    <InputLabel style={{ fontWeight: 500 }}>
                      {TaxType === "GST"
                        ? `GST (${gstPercentage ? gstPercentage : currencyType === "INR" ? 18 : 0}%)`
                        : `VAT (${vtPercentage || 0}%)`}
                    </InputLabel>
                    <InputLabel style={{ fontWeight: 500 }}>
                      {currencySymbol}
                      {convertedGstAmount.toFixed(2)}
                    </InputLabel>
                  </div>

                  <hr className="user_pending_line" />

                  <div className="user_amount_sub">
                    <InputLabel style={{ fontWeight: 500 }}>Total:</InputLabel>
                    <InputLabel style={{ fontWeight: 500 }}>
                      {currencySymbol}
                      {finalAmount}
                    </InputLabel>
                  </div>
                </div>
              </div>

              <div className="user_pending_checkbox">
                <CheckboxInput type="checkbox" />
                <CheckboxLabel>I agree to Pay amount</CheckboxLabel>
              </div>
            </div>

            <div className="user_card_form">
              <div className="user_card_form_label">
                <InputType
                  placeholder="Enter Your Company Name"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                />
              </div>

              {/* ✅ DYNAMIC TAX NUMBER FIELD */}
              {(currencyType === "INR" || (currencyType !== "INR" && currencyType !== "USD" && currencyType !== "AED")) ? (
                <div className="user_card_form_label">
                  <InputType
                    placeholder="Enter GST Number"
                    value={gstNumber}
                    onChange={(e) => setGstNumber(e.target.value)}
                  />
                </div>
              ) : (currencyType === "USD" || currencyType === "AED") ? (
                <div className="user_card_form_label">
                  <InputType
                    placeholder="Enter VAT Number"
                    value={vatNumber}
                    onChange={(e) => setVatNumber(e.target.value)}
                  />
                </div>
              ) : null}


              <div className="user_card_form_btn">{renderPaymentMethods()}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
